import { Select, Theme, styled } from '@mui/material';
import { CoreRadio, CoreRadioGroup } from '@youscience/core';

import ActionButton from '@components/ActionButton';

export const sxStyles = {
  subtitle: {
    padding: '0.5rem 0.5rem 1.5rem 0.5rem',
    textAlign: 'center',
  },
  deadlineHelperText: {
    marginTop: '0.375rem',
    fontSize: '0.75rem',
  },
  formControlItem: {
    marginTop: '1.25rem',
    width: '300px',

    ' & .MuiFormControl-root': {
      width: '100%',
    },
  },
  priorityLabel: {
    fontSize: '0.875rem',
    marginLeft: '1rem',
    color: '#666666',

    ' & label.Mui-focused': {
      color: 'red',
    },
  },
  scoreLabel: {
    marginTop: '0.375rem',
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    width: '82px',
  },
  radioGroup: {
    margin: '0',
  },
  radioWrap: {
    textAlign: 'center',
  },
};

export const StyledWrap = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '432px',
  width: '100%',
  margin: '0 auto',
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  boxShadow: 'none',

  '& > svg:first-of-type': {
    color: theme.palette.common.black,
  },
}));

export const MenuPropsStyles = {
  PaperProps: {
    sx: (theme: Theme) => ({
      '& .Mui-selected': {
        backgroundColor: theme.palette.grey['100'],
      },

      li: {
        '&:hover': {
          // TODO add color to library
          backgroundColor: '#EBF6F7',
        },
      },
    }),
  },
};

export const StyledRadioGroup = styled(CoreRadioGroup)(() => ({
  marginTop: '2rem',
  marginBottom: '2rem',
}));

export const StyledScoreButtonsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  maxWidth: '44px',

  '> :not(:first-of-type)': {
    marginLeft: '0.5rem',
  },

  [theme.breakpoints.up('sm')]: {
    '> :not(:first-of-type)': {
      marginLeft: '2rem',
    },
  },
}));

export const StyledScoreRadioButton = styled(ActionButton, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ isSelected, theme }) => ({
  backgroundColor: isSelected ? theme.palette.primary.main : theme.palette.common.white,
  border: `1px solid ${theme.palette.grey['300']}`,
  borderRadius: '4px',
  color: isSelected ? theme.palette.common.white : theme.palette.common.black,
  position: 'relative',
  minWidth: '44px',
  height: '44px',
  padding: 0,

  '&:hover': {
    // TODO add colors to library
    backgroundColor: isSelected ? theme.palette.primary.main : '#EBF6F7',
  },
}));

export const StyledRadio = styled(CoreRadio)(() => ({
  position: 'absolute',
  opacity: 0,
  zIndex: 100,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}));
